import { FunctionComponent, useContext, useState } from 'react'
import { ThemeContext } from 'styled-components'

import HomeOutlined from 'design-system/Iconography/SVG/HomeOutlined'

import { useElement, useWindowSize } from 'services/hooks'

import HomeTypeDropdown from '../Dropdowns/HomeTypeDropdown'
import HomeTypeMobileSheet from '../MobileSheets/HomeTypeMobileSheet'
import { IHomeTypeProps, IMobileSheetProps } from '../types'
import FilterButton from './Shared/FilterButton'

const renderIcon = () => <HomeOutlined />

const HomeTypeFilter: FunctionComponent<IHomeTypeProps & IMobileSheetProps> = ({
  selectedHomeTypes,
  setSelectedHomeTypes,
  applyHomeTypeSelections,
  resetHomeTypeSelections,
  ...mobileFilterSheetProps
}) => {
  const theme = useContext(ThemeContext)
  const { width } = useWindowSize()
  const isMobile = width && width < theme.metrics.tablet

  const [buttonRef, buttonElement] = useElement<HTMLDivElement>()
  const [visible, setVisible] = useState(false)

  const [applied, setApplied] = useState(false)
  const [label, setLabel] = useState('Home Type')

  const clearSelection = () => {
    resetHomeTypeSelections()
    setLabel('Home Type')
    setApplied(false)
    setVisible(false)
  }

  const handleApply = () => {
    // equivalent to clearing the selection
    if (selectedHomeTypes.length === 0) return clearSelection()

    applyHomeTypeSelections()
    setApplied(true)

    if (selectedHomeTypes.length === 0) setLabel('Home Type')
    else if (selectedHomeTypes.length === 1) setLabel(selectedHomeTypes[0])
    else setLabel(selectedHomeTypes.join(', '))

    setVisible(false)
  }

  // must be initialized or UI will show wrong UI to start
  if (!width) return null

  const refProps = isMobile ? {} : { ref: buttonRef }
  const onClickProps = isMobile ? { onClick: mobileFilterSheetProps.showMobileFilterSheet } : {}

  return (
    <>
      <FilterButton
        active={applied || visible}
        label={label}
        renderIcon={renderIcon}
        onClearSelection={clearSelection}
        clearable={applied}
        {...refProps}
        {...onClickProps}
      />
      <HomeTypeMobileSheet
        selectedHomeTypes={selectedHomeTypes}
        setSelectedHomeTypes={setSelectedHomeTypes}
        onApply={handleApply}
        onReset={clearSelection}
        {...mobileFilterSheetProps}
      />
      <HomeTypeDropdown
        buttonElement={buttonElement}
        visible={visible}
        setVisible={setVisible}
        onApply={handleApply}
        selectedHomeTypes={selectedHomeTypes}
        setSelectedHomeTypes={setSelectedHomeTypes}
        applyHomeTypeSelections={applyHomeTypeSelections}
        resetHomeTypeSelections={clearSelection}
      />
    </>
  )
}

export default HomeTypeFilter
